import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaEventService } from '../../../services/ga-event.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';

@Component({
  selector: 'change-invoice-mail-address-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class ChangeInvoiceMailAddressActionComponent extends BaseReportActionsDialog implements OnInit {
  constructor(
    private formlyService: GaFormlyService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // init model
    this.model = {
      invoiceEmailAddress: undefined
    };

    // create fields
    this.fields = this.createFields();
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.anInput('invoiceEmailAddress', 'E-invoice mail address')
        .withLabelClass('col-sm-4')
        .withValueClass('col-sm-8')
        .isRequired()
        .build()
    ];
  }
}